export const StripeBar = ({ className = "" }) => (
  <div className={`flex ${className}`} aria-hidden="true">
    <span className="h-full flex-1 bg-crimson" />
    <span className="h-full flex-1 bg-cream" />
    <span className="h-full flex-1 bg-royal" />
  </div>
);

export default StripeBar;
